import React from 'react';
import { Movie } from '../../models/paginatedMovie.model';
import "./CardMovie.scss";
import { useNavigate } from 'react-router-dom';

export type CardMovieProp = {
  movie: Movie;
}
const CardMovie = ({ movie }: CardMovieProp) => {

  const imageURL = "https://image.tmdb.org/t/p/w300/";
  const navigate = useNavigate();
  
  const formatReleaseDate = (releaseDate: string) => {
    if (!releaseDate) return '';
    const date = new Date(releaseDate);
    const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
  }

  const formatPopularity = (popularity: number) => {
    return Math.round(popularity * 10) / 10;
  }

  const formatVoteAverage = (voteAverage: number) => {
    return voteAverage.toFixed(1);
  }

  const handleCardClick = () => {
    navigate(`/movie/${movie.id}`); // Navegue para a página de detalhes do filme
  };


  return (
    <div className="card-container" onClick={handleCardClick}>
      <img className="img-card" src={`${imageURL}${movie.backdrop_path}`} alt="image backdrop" />
      <h2>
        {movie.title}
      </h2>
      <div className="card-info">
        <p className="card-year">
          Release date: <strong>{formatReleaseDate(movie.release_date)}</strong>
        </p>
        <div className="card-stats">
          <span className="vote-average">
            ⭐ Rating: {formatVoteAverage(movie.vote_average)}
          </span>
          <span className="popularity">
            🔥 Popularity: {formatPopularity(movie.popularity)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default CardMovie;